import axios from "axios";
import { API_URL } from "../constants";
import APIKit from "../APIKit";

function getJobs(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }
    APIKit.post("/explore_jobs", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}
function cancelQuote(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      } else {
      }
    } catch (e) {
    }
    APIKit.post("/cancel_quote", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}
function submitquote(payload, isupdate) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      } else {
      }
    } catch (e) {
    }
    APIKit.post(isupdate == true ? "/update_quote" : "/submit_quote", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function postjob(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        payload.append("auth_token", token);
      } else {
      }
    } catch (e) {
    }
    APIKit.post("/post_job", payload)
      .then(async (response) => {
        try {


          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function getJobById(jobId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = window.localStorage.getItem("auth_token");
      if (token) {
        const form = new FormData();
        form.append("auth_token", token);
        form.append("job_id", jobId);
        
        APIKit.post("/get_single_job", form)
          .then(async (response) => {
            try {
              resolve(response.data);
            } catch (e) {
              reject(e);
            }
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        reject(new Error("No auth token found"));
      }
    } catch (e) {
      reject(e);
    }
  });
}

export const JobService = {
  getJobs,
  getJobById,
  submitquote,
  postjob,
  cancelQuote
};
